import React from "react";
import { Linkedin, Rss, Cookie } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";
import { openCookieSettings } from "./CookieConsent";

const LINKEDIN_URL = "https://www.linkedin.com/in/nextechlaw/";
const NEWSLETTER_URL =
  "https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7379873272445894656";

export const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-[#030712] pt-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 pb-10 border-b border-white/10">
          <div>
            <div className="font-display text-2xl font-extrabold text-white">
              NexTech<span className="text-[#3B82F6]">.Law</span>
            </div>
            <div className="mt-2 font-mono-tech text-xs text-gray-400 tracking-wider">{t.footer.tagline}</div>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="inline-flex items-center gap-2 border border-white/15 hover:border-[#0052FF] hover:bg-[#0052FF]/10 text-white text-sm px-4 py-2 rounded-sm transition-colors duration-200"
            >
              <Linkedin size={16} className="text-[#3B82F6]" />
              {t.footer.linkedin}
            </a>
            <a
              href={NEWSLETTER_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-newsletter"
              className="inline-flex items-center gap-2 border border-white/15 hover:border-[#0052FF] hover:bg-[#0052FF]/10 text-white text-sm px-4 py-2 rounded-sm transition-colors duration-200"
            >
              <Rss size={16} className="text-[#3B82F6]" />
              {t.footer.newsletter}
            </a>
          </div>
        </div>
        <div className="py-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="font-mono-tech text-xs text-gray-400">
            {`© ${year} NexTech.Law · ${t.footer.rights}`}
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 font-mono-tech text-xs text-gray-400">
            <Link to="/insights" className="hover:text-white transition-colors" data-testid="footer-insights">Insights</Link>
            <Link to="/impressum" className="hover:text-white transition-colors" data-testid="footer-imprint">{t.footer.imprint}</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors" data-testid="footer-privacy">{t.footer.privacy}</Link>
            <Link to="/agb" className="hover:text-white transition-colors" data-testid="footer-terms">{t.footer.terms}</Link>
            <button
              type="button"
              onClick={openCookieSettings}
              data-testid="footer-cookie-settings"
              className="inline-flex items-center gap-1.5 hover:text-white transition-colors"
            >
              <Cookie size={12} className="text-[#3B82F6]" />
              {t.footer.cookieSettings}
            </button>
          </div>
        </div>
      </div>
      {/* Oversized brand mark */}
      <div className="select-none pointer-events-none leading-none text-center">
        {/* Decorative footer flourish — non-text (contrast-safe), keeps the
            brand-blue accent without a giant ghost wordmark. */}
        <div aria-hidden="true" className="-mb-[3vw] h-[6vw] max-h-24 bg-gradient-to-r from-transparent via-[#0052FF]/25 to-transparent blur-2xl" />
      </div>
    </footer>
  );
};
